<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'HipaaFormValidation',
    props: {
        playerID: {
            type: String,
            required: true,
        },
        playerEmail: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            hipaaAnnualFormValidation: {},
            hipaaAnnualFormSharepointUrl: process.env.VUE_APP_SHAREPOINT_URL_PLAYER_HIPAA_FORMS,
        };
    },
    emits: ['is-hipaa-form-valid'],
    mounted() {
        this.getPlayerHipaaConsentForm({
            playerIdentifier: this.playerID,
            playerEmail: this.playerEmail,
        })
            .then((response) => {
                this.hipaaAnnualFormValidation = response;
            })
            .catch((error) => {
                console.error(error);
                this.$message({
                    showClose: true,
                    message:
                        'Could not retrieve information from WTA backend systems. ' +
                        'Retrying in 5 seconds. If the problem persists then contact the Administrator',
                    type: 'error',
                    duration: 0,
                });
            });
    },
    computed: {
        ...mapGetters('playerConsentFormStore', ['hasTheHipaaConsentFormBeenSigned', 'loadingPlayerHipaaConsentFormError']),
    },
    watch: {
        isHipaaFormValid: {
            handler() {
                this.$emit('is-hipaa-form-valid', this.hasTheHipaaConsentFormBeenSigned);
            },
            deep: true,
        },
    },
    methods: {
        ...mapActions('playerConsentFormStore', ['getPlayerHipaaConsentForm']),
    },
};
</script>

<template>
    <div>
        <el-card width="50%" class="profile-card">
            <div slot="header">
                <b>Health Authorization Form</b>
            </div>
            <div v-if="hasTheHipaaConsentFormBeenSigned">Valid</div>
            <div v-else-if="loadingPlayerHipaaConsentFormError === null">
                Your Health Authorization Form are due and need to be completed. Please proceed to
                <a class="request-link" :href="hipaaAnnualFormSharepointUrl">
                    your Health Authorization Form
                </a>to update your status.
            </div>
            <div v-else>
                {{ loadingPlayerHipaaConsentFormError }}
            </div>
        </el-card>
    </div>
</template>

<style scoped lang="scss"></style>
